/**
 * <StudentHomeFollowingLives> — sous la carte du prochain live de l'élève, les lives qui suivent
 * (Wajih, 18/10) : deux au plus, en lignes courtes (`<SessionRow>`), puis « Tous mes lives », dans
 * UNE carte-liste, sous l'intitulé « À venir » de l'accueil parent.
 *
 * Les lignes disent le jour comme on le dit (« Demain · 18h00 ») et de quelle absence une séance est
 * le rattrapage, comme les listes de l'élève (`relativeDay`, `showRecoveryInfo`). Les séances
 * montrées sont l'affaire du view-model. Toucher une ligne répond comme la carte du prochain live :
 * l'écran ouvre SA séance, ou la boîte qui dit quand.
 *
 * « Tous mes lives » reste, même sans ligne : c'est le chemin vers la liste entière, et vers
 * « Prévenir d'une absence ». Sans ligne ni lien, rien.
 */
import React from "react"

import { CardList, CardListLinkRow } from "../../molecules/CardList"
import { List } from "../../molecules/List"
import { SessionRow } from "../../molecules/SessionRow"
import { SessionRowSkeleton } from "../../molecules/SessionRow/SessionRowSkeleton"
import { type UILiveSession } from "../../../ports/primary/ui/types"

const TITLE = "À venir"

export type StudentHomeFollowingLivesProps = {
    /** Les lives après le prochain, triés et coupés par le view-model. */
    sessions: UILiveSession[]
    /** Une ligne touchée. Absent : les lignes ne pressent pas. */
    onSelectSession?: (session: UILiveSession) => void
    /** « Tous mes lives ». Absent : pas de lien. */
    onOpenAllLives?: () => void
    testID?: string
}

export function StudentHomeFollowingLives(props: StudentHomeFollowingLivesProps) {
    const { sessions, onSelectSession, onOpenAllLives, testID } = props
    if (sessions.length === 0 && onOpenAllLives == null) return null

    return (
        <List title={TITLE} testID={testID}>
            <CardList>
                {sessions.map((session) => (
                    <SessionRow
                        key={session.id}
                        session={session}
                        relativeDay
                        showRecoveryInfo
                        onPress={onSelectSession != null ? () => onSelectSession(session) : undefined}
                    />
                ))}
                {onOpenAllLives != null && <CardListLinkRow label="Tous mes lives" onPress={onOpenAllLives} />}
            </CardList>
        </List>
    )
}

/** Sa forme dans le squelette de l'accueil : l'intitulé, et les deux lignes du cas courant. */
export function StudentHomeFollowingLivesSkeleton() {
    return (
        <List title={TITLE}>
            <CardList>
                <SessionRowSkeleton />
                <SessionRowSkeleton />
            </CardList>
        </List>
    )
}
